import { DownloadPlatformOs } from 'shared/api/containerApi'

export const detectPlatformOs = (): DownloadPlatformOs | undefined => {
  if (typeof navigator === 'undefined') return undefined

  const platform =
    (navigator as { userAgentData?: { platform?: string } }).userAgentData
      ?.platform ||
    navigator.platform ||
    navigator.userAgent ||
    ''

  const value = platform.toLowerCase()

  if (value.includes('mac')) return 'mac'
  if (value.includes('win')) return 'windows'
  if (value.includes('linux') || value.includes('x11')) return 'linux'

  return undefined
}
